import React from "react";

export default function InternationalCircuit() {
  return (
    <section className="py-20 bg-gradient-to-br from-slate-900 to-gray-900 text-white relative overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h3 className="text-3xl md:text-4xl font-black tracking-tight text-center mb-8">
          RecruitLook Hoops is an <span className="text-secondary">International Circuit</span>
        </h3>

        <div className="flex justify-center mb-6">
          <img 
            src="/lovable-uploads/5e021bb5-363c-411f-a223-037c9f0b8760.png"
            alt="United States map showing RecruitLook Hoops coverage"
            className="max-w-full h-auto"
            style={{
              filter: "drop-shadow(0 4px 12px rgba(0,0,0,0.3))",
              maxWidth: "800px"
            }}
          />
        </div>
        
        <p className="text-center mt-6 text-white/80 text-sm">Highlighted states represent active participation on the circuit.</p>
        <p className="text-center mt-4 text-white text-xl md:text-2xl">We had the United States, Canada, Serbia, and Australia in 2025. We'll add England in 2026!</p>
      </div>
    </section>
  );
}
